// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1RtOL","alertIcon":"ConfirmModal_alertIcon__3BkKd"};